import { render, staticRenderFns } from "./ReplacementItems.vue?vue&type=template&id=5b172a1e&scoped=true"
import script from "./ReplacementItems.ts?vue&type=script&lang=ts&external"
export * from "./ReplacementItems.ts?vue&type=script&lang=ts&external"
import style0 from "./ReplacementItems.scss?vue&type=style&index=0&id=5b172a1e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b172a1e",
  null
  
)

export default component.exports